"use strict";

define('libs/dashboard.helper',['require','exports','module','underscore','moment','../config','../view/dashboard.button','../view/dashboard.card','../view/empty.table','uikit/uikit','../view/meeting.summary','../model/user','../model/document','../model/study','../model/task','../model/meeting','../model/sort','../model/paginate','../libs/spf.helper','../libs/loader.helper','../libs/route.helper','../libs/format/link','../libs/format/bold','../libs/format/date','../libs/filter_format/expirationDate','../libs/filter_format/analyst','langs'],function (require, exports, module) {
  var _ = require('underscore'),
    moment = require('moment'),
    config = require('../config'),
    DashboardButton = require('../view/dashboard.button'),
    DashboardCard = require('../view/dashboard.card'),
    EmptyTableView = require('../view/empty.table'),
    UIKit = require('uikit/uikit'),
    MeetingSummary = require('../view/meeting.summary'),
    User = require('../model/user'),
    Document = require('../model/document'),
    Study = require('../model/study'),
    Task = require('../model/task'),
    Meeting = require('../model/meeting'),
    Sort = require('../model/sort'),
    Paginate = require('../model/paginate'),
    SPFHelper = require('../libs/spf.helper'),
    LoaderHelper = require('../libs/loader.helper'),
    RouteHelper = require('../libs/route.helper'),
    linkFormatter = require('../libs/format/link'),
    boldFormatter = require('../libs/format/bold'),
    dateFormatter = require('../libs/format/date'),
    expirationDateFormatter = require('../libs/filter_format/expirationDate'),
    analystFormatter = require('../libs/filter_format/analyst'),
    langs = require('langs');
  var TextView = UIKit.Text,
    TableView = UIKit.Table,
    Dropdown = UIKit.Dropdown,
    ContainerView = UIKit.Container,
    Calendar = UIKit.Calendar,
    PopupView = UIKit.Popup,
    ButtonView = UIKit.Button,
    p = langs.phrase,
    dh;
  var CardContainerWithDropdownView = ContainerView.extend({
    labelSlug: '',
    dropdown: {},
    initialize: function initialize() {
      ContainerView.prototype.initialize.apply(this, arguments);
      var containerView = this;
      var setH3AriaLabel = function setH3AriaLabel(selectedValue) {
        var $h3 = containerView.$el.find('h3');
        var ariaLabel = containerView.labelSlug + selectedValue.get('text');
        $h3.attr('aria-label', ariaLabel);
      };
      this.on('render', function () {
        setH3AriaLabel(containerView.dropdown.value);
      });
      this.on('childview:change:value', function (dropdownView) {
        setH3AriaLabel(dropdownView.value);
      });
    }
  });
  var CASE__ORG_APPROVER = 'orgSubmissions';
  var CASE__ANALYST_ME = 'analystAssignedToMe';
  var CASE__ANALYST_UNASSIGNED = 'analystUnassigned';
  var CASE__ADMIN_ME = 'adminAssignedToMe';
  var CASE__ADMIN_UNASSIGNED = 'adminUnassigned';
  var FILTER_KEY__CASE = 'case';
  var FILTER_KEY__ROLE = 'role';
  var FILTER_KEY__ASSIGNMENT = 'assignment';
  var dashboardHelper = dh = {
    cardDefaults: {
      pageSize: 5
    },
    filterFormatters: {
      expirationDate: expirationDateFormatter,
      analyst: analystFormatter
    },
    studySort: {
      sort: 'activityDate',
      sortDirection: Sort.DESCENDING
    },
    taskSort: {
      sort: 'taskBeginDate',
      sortDirection: Sort.DESCENDING
    },
    submissionSort: {
      sort: 'activityDate',
      sortDirection: Sort.DESCENDING
    },
    studyColumns: [{
      data: 'label',
      formatter: linkFormatter('study:detail', {
        studyId: 'id'
      }),
      nowrap: true
    }, {
      data: 'title',
      formatter: boldFormatter
    }],
    taskColumns: [{
      data: 'studyLabel',
      formatter: linkFormatter('submission:detail', {
        studyId: 'studyId',
        documentId: 'documentId'
      }),
      nowrap: true
    }, {
      data: 'taskDisplayName',
      formatter: boldFormatter
    }],
    submissionColumns: [{
      data: 'studyLabel',
      formatter: linkFormatter('submission:detail', {
        studyId: 'studyId',
        documentId: 'id'
      }),
      nowrap: true
    }, {
      data: 'studyTitle',
      formatter: boldFormatter
    }],
    ensureCountCanBeDisplayedInTextBinding: function ensureCountCanBeDisplayedInTextBinding(model, l) {
      model.set('count', String(model.get('count')));
      model.loader = l;
      return model;
    },
    createReviewTypeButtons: function createReviewTypeButtons(forReviewer, authority, options) {
      var roleFilter = authority === User.IRB_ADMIN ? {} : {
        role: authority
      };
      var fullButtonOptions = {
        icon: 'blue users',
        linkName: 'submission:list',
        bindings: {
          text: 'count'
        },
        linkFilter: _.extend({
          reviewType: 'Full',
          status: Document.UNDER_REVIEW_AND_POST_REVIEW.join('|')
        }, roleFilter),
        arrowIcon: 'blue right short arrow icon'
      };
      if (forReviewer) {
        var reviewerFullButtonOptions = {
          ariaLabelText: p('Dashboard.Cards.SubUnderRev.Full'),
          subText: new Handlebars.SafeString(p('Dashboard.Buttons.FullBoardReviews')),
          large: true
        };
        fullButtonOptions = _.extend({}, fullButtonOptions, reviewerFullButtonOptions);
      } else {
        var analystFullButtonOptions = {
          minHeight: null,
          tagSize: 'div',
          basic: false,
          subText: p('Dashboard.Cards.SubUnderRev.Full')
        };
        fullButtonOptions = _.extend({}, fullButtonOptions, analystFullButtonOptions);
      }
      var fullButton = dh.createButtonWithSharedCollection(fullButtonOptions);
      var expeditedButtonOptions = {
        icon: 'blue rocket',
        linkName: 'submission:list',
        bindings: {
          text: 'count'
        },
        linkFilter: _.extend({
          reviewType: 'Expedited',
          status: Document.UNDER_REVIEW_AND_POST_REVIEW.join('|')
        }, roleFilter),
        arrowIcon: 'blue right short arrow icon'
      };
      if (forReviewer) {
        var reviewerExpeditedButtonOptions = {
          ariaLabelText: p('Dashboard.Cards.SubUnderRev.Expedited'),
          subText: new Handlebars.SafeString(p('Dashboard.Buttons.ExpeditedReviews')),
          large: true
        };
        expeditedButtonOptions = _.extend({}, expeditedButtonOptions, reviewerExpeditedButtonOptions);
      } else {
        var analystExpeditedButtonOptions = {
          minHeight: null,
          tagSize: 'div',
          basic: false,
          subText: p('Dashboard.Cards.SubUnderRev.Expedited')
        };
        expeditedButtonOptions = _.extend({}, expeditedButtonOptions, analystExpeditedButtonOptions);
      }
      var expeditedButton = dh.createButtonWithSharedCollection(expeditedButtonOptions);
      var limitedButtonOptions = {
        icon: 'blue street view',
        linkName: 'submission:list',
        bindings: {
          text: 'count'
        },
        linkFilter: _.extend({
          reviewType: 'Limited',
          status: Document.UNDER_REVIEW_AND_POST_REVIEW.join('|')
        }, roleFilter),
        arrowIcon: 'blue right short arrow icon'
      };
      if (forReviewer) {
        var reviewerLimitedButtonOptions = {
          ariaLabelText: p('Dashboard.Cards.SubUnderRev.Limited'),
          subText: new Handlebars.SafeString(p('Dashboard.Buttons.LimitedIRBReviews')),
          large: true
        };
        limitedButtonOptions = _.extend({}, limitedButtonOptions, reviewerLimitedButtonOptions);
      } else {
        var analystLimitedButtonOptions = {
          minHeight: null,
          tagSize: 'div',
          basic: false,
          subText: p('Dashboard.Cards.SubUnderRev.Limited')
        };
        limitedButtonOptions = _.extend({}, limitedButtonOptions, analystLimitedButtonOptions);
      }
      var limitedButton = dh.createButtonWithSharedCollection(limitedButtonOptions);
      var exemptButtonOptions = {
        icon: 'blue user',
        linkName: 'submission:list',
        bindings: {
          text: 'count'
        },
        linkFilter: _.extend({
          reviewType: 'Exempt',
          status: Document.UNDER_REVIEW_AND_POST_REVIEW.join('|')
        }, roleFilter),
        arrowIcon: 'blue right short arrow icon'
      };
      if (forReviewer) {
        var reviewerExemptButtonOptions = {
          ariaLabelText: p('Dashboard.Cards.SubUnderRev.Exempt'),
          subText: new Handlebars.SafeString(p('Dashboard.Buttons.ExemptReviews')),
          large: true
        };
        exemptButtonOptions = _.extend({}, exemptButtonOptions, reviewerExemptButtonOptions);
      } else {
        var analystExemptButtonOptions = {
          minHeight: null,
          tagSize: 'div',
          basic: false,
          subText: p('Dashboard.Cards.SubUnderRev.Exempt')
        };
        exemptButtonOptions = _.extend({}, exemptButtonOptions, analystExemptButtonOptions);
      }
      var exemptButton = dh.createButtonWithSharedCollection(exemptButtonOptions);
      var adminButtonOptions = {
        icon: 'blue list alt',
        linkName: 'submission:list',
        bindings: {
          text: 'count'
        },
        linkFilter: _.extend({
          reviewType: 'Administrative',
          status: Document.UNDER_REVIEW_AND_POST_REVIEW.join('|')
        }, roleFilter),
        arrowIcon: 'blue right short arrow icon'
      };
      if (forReviewer) {
        var reviewerAdminButtonOptions = {
          ariaLabelText: p('Dashboard.Cards.SubUnderRev.Admin'),
          subText: new Handlebars.SafeString(p('Dashboard.Buttons.AdminReviews')),
          large: true
        };
        adminButtonOptions = _.extend({}, adminButtonOptions, reviewerAdminButtonOptions);
      } else {
        var analystAdminButtonOptions = {
          minHeight: null,
          tagSize: 'div',
          basic: false,
          subText: p('Dashboard.Cards.SubUnderRev.Admin')
        };
        adminButtonOptions = _.extend({}, adminButtonOptions, analystAdminButtonOptions);
      }
      var adminButton = dh.createButtonWithSharedCollection(adminButtonOptions);
      var theButtons = {};
      theButtons[config.FULL_REVIEW_TYPE] = fullButton;
      theButtons[config.EXPEDITED_REVIEW_TYPE] = expeditedButton;
      theButtons[config.LIMITED_REVIEW_TYPE] = limitedButton;
      theButtons[config.EXEMPT_REVIEW_TYPE] = exemptButton;
      theButtons[config.ADMIN_REVIEW_TYPE] = adminButton;
      return theButtons;
    },
    buttons: function buttons(authority, options) {
      var viewOptions = [],
        roleFilter = authority === User.IRB_ADMIN ? {} : {
          role: authority
        },
        buttons = [];
      options = options || {};
      switch (authority) {
        case User.IRB_USER:
        case User.IRB_ANALYST:
        case User.IRB_ADMIN:
        case User.IRB_ORG_APPROVER:
          var inDraftButton = dh.createButtonWithSharedCollection({
            icon: 'blue edit',
            subText: p('Dashboard.Buttons.InDraft'),
            linkName: 'submission:list',
            large: true,
            arrowIcon: 'blue right short arrow icon',
            linkFilter: _.extend({
              status: Document.IN_DRAFT.join('|')
            }, roleFilter)
          });
          var awaitingApprovalButton = dh.createButtonWithSharedCollection({
            icon: 'blue university',
            subText: p('Dashboard.Buttons.AwaitingApproval'),
            linkName: 'submission:list',
            large: true,
            arrowIcon: 'blue right short arrow icon',
            linkFilter: _.extend({
              status: Document.IN_APPROVALS.join('|')
            }, roleFilter)
          });
          var preReviewButton = dh.createButtonWithSharedCollection({
            icon: 'blue folder open outline',
            subText: p('Dashboard.Buttons.PreReview'),
            linkName: 'submission:list',
            large: true,
            arrowIcon: 'blue right short arrow icon',
            linkFilter: _.extend({
              status: Document.PRE_REVIEW.join('|')
            }, roleFilter)
          });
          var underReviewButton = dh.createButtonWithSharedCollection({
            icon: 'blue browser',
            subText: p('Dashboard.Buttons.UnderReview'),
            linkName: 'submission:list',
            large: true,
            arrowIcon: 'blue right short arrow icon',
            linkFilter: _.extend({
              status: Document.UNDER_REVIEW.join('|')
            }, roleFilter)
          });
          var postReviewButton = dh.createButtonWithSharedCollection({
            subText: p('Dashboard.Buttons.PostReview'),
            linkName: 'submission:list',
            large: true,
            arrowIcon: 'blue right short arrow icon',
            minHeight: 68,
            iconURL: config.staticRoot,
            linkFilter: _.extend({
              status: Document.POST_REVIEW.join('|')
            }, roleFilter)
          });
          buttons.push(inDraftButton, awaitingApprovalButton, preReviewButton, underReviewButton, postReviewButton);
          return buttons;
        case User.IRB_REVIEWER:
          var theButtons = dh.createReviewTypeButtons(true, authority, options);
          buttons.push(theButtons[config.FULL_REVIEW_TYPE], theButtons[config.EXPEDITED_REVIEW_TYPE], theButtons[config.LIMITED_REVIEW_TYPE], theButtons[config.EXEMPT_REVIEW_TYPE], theButtons[config.ADMIN_REVIEW_TYPE]);
          return buttons;
      }
    },
    cards: function cards(authority) {
      var cards = [],
        options = {
          authority: authority
        };
      if (authority === User.IRB_REVIEWER) {
        cards.push(dh.createReviewerSubmissionsCard(options));
      }
      if (authority === User.IRB_USER) {
        cards.push(dh.createMyStudiesCard(options));
      }
      if (authority === User.IRB_ANALYST || authority === User.IRB_ADMIN) {
        cards.push(dh.createAnalystSubmissionsCard(options));
      }
      if (authority === User.IRB_ORG_APPROVER) {
        options = {
          authority: authority,
          "case": CASE__ORG_APPROVER
        };
        cards.push(dh.createRecentOrgSubmissions(options));
      }
      cards.push(dh.createMyTasksCard(options));
      cards.push(dh.createSubmissionTypeCard(options));
      if (authority === User.IRB_ANALYST || authority === User.IRB_ADMIN) {
        cards.push(dh.createUnderReviewSubmissionCard(options));
      }
      if (authority === User.IRB_USER || authority === User.IRB_REVIEWER || authority === User.IRB_ORG_APPROVER) {
        cards.push(dh.createApprovedStudiesCard(options));
      }
      if (authority === User.IRB_USER || authority === User.IRB_ANALYST || authority === User.IRB_ADMIN || authority === User.IRB_ORG_APPROVER) {
        cards.push(dh.createExpiringStudiesCard(options));
      }
      if (authority === User.IRB_USER || authority === User.IRB_ORG_APPROVER) {
        cards.push(dh.createExpiredStudiesCard(options));
      }
      if (authority === User.IRB_ANALYST || authority === User.IRB_REVIEWER || authority === User.IRB_ADMIN) {
        cards.push(dh.createMeetingsCard(options));
      }
      if (authority === User.IRB_REVIEWER) {
        cards.push(dh.createUpcomingReviewsCard(options));
      }
      return cards;
    },
    createMyStudiesCard: function createMyStudiesCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var studyHelper = new SPFHelper(Study.all());
      if (options.authority !== User.IRB_ADMIN) {
        studyHelper.filter.set({
          role: options.authority
        });
      }
      studyHelper.paginate.set(Paginate.SIZE, options.pageSize);
      studyHelper.sort.set(dh.studySort);
      return dh.createCard({
        collection: studyHelper.collection,
        filter: studyHelper.filter,
        emptyViewOptions: {
          text: 'You Have No Studies'
        },
        linkName: 'study:list',
        color: 'primary',
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.MyStudies')),
          color: 'blue'
        }),
        rowLinkName: 'study:detail',
        columns: dh.studyColumns,
        viewAllHelpText: 'My Studies',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createMyTasksCard: function createMyTasksCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var taskHelper = new SPFHelper(Task.all(), {
        autoFetch: true
      });
      if (options.authority !== User.IRB_ADMIN) {
        taskHelper.filter.set(FILTER_KEY__ROLE, options.authority);
      }
      taskHelper.paginate.set(Paginate.SIZE, options.pageSize);
      taskHelper.sort.set(dh.taskSort);
      return dh.createCard({
        collection: taskHelper.collection,
        filter: taskHelper.filter,
        emptyViewOptions: {
          text: 'All Tasks Complete',
          icon: 'check'
        },
        linkName: 'task:list',
        rowLinkName: 'submission:detail',
        color: 'primary',
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.MyTasks')),
          color: 'blue'
        }),
        columns: dh.taskColumns,
        viewAllHelpText: 'My Tasks',
        columnNames: ['IRB Number', 'Task']
      });
    },
    createSubmissionTypeCard: function createSubmissionTypeCard(options) {
      options = _.extend({}, dh.cardDefaults, options);
      var roleFilter = options.authority === User.IRB_ADMIN ? {} : {
        role: options.authority
      };
      var templateTypes = Document.submissionCountsGroupedBy(Document.TEMPLATE_TYPE, options.authority);
      var loaderHelper = new LoaderHelper([templateTypes]);
      loaderHelper.set('loading', true);
      var card = dh.createCard({
        collection: templateTypes,
        emptyViewOptions: {
          text: 'No Recent Activity'
        },
        color: 'primary',
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString('<b>Submissions</b> by Type'),
          color: 'blue'
        }),
        columns: [{
          data: 'templateType'
        }, {
          align: 'right',
          childView: TextView.extend({
            attributes: {
              style: 'font-weight: bold;'
            }
          }),
          childViewOptions: {
            color: 'blue',
            bindings: {
              text: 'count'
            }
          },
          collapsing: true
        }],
        viewAllHelpText: 'Submissions by Type',
        columnNames: ['Submission Type', 'Submissions']
      });
      function getSubmissionLink(model) {
        return new RouteHelper('submission:list').ignore(FILTER_KEY__ROLE).ignore(FILTER_KEY__CASE).add(model, {
          templateType: 'templateType'
        }).get('link');
      }
      card.content.rowLinkFormatter = function (model) {
        return getSubmissionLink(model);
      };
      return card;
    },
    createApprovedStudiesCard: function createApprovedStudiesCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var taskHelper = new SPFHelper(Study.all(), {
        autoFetch: true
      });
      taskHelper.paginate.set(Paginate.SIZE, options.pageSize);
      taskHelper.filter.set({
        status: 'Approved'
      });
      if (options.authority != User.IRB_ADMIN) {
        taskHelper.filter.set(FILTER_KEY__ROLE, options.authority);
      }
      taskHelper.sort.set(dh.studySort);
      return dh.createCard({
        collection: taskHelper.collection,
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.ApprovedStudies')),
          color: 'blue'
        }),
        filter: taskHelper.filter,
        emptyViewOptions: {
          text: 'No Approved Studies'
        },
        linkName: 'study:list',
        rowLinkName: 'submission:detail',
        color: 'primary',
        columns: dh.studyColumns,
        viewAllHelpText: 'Approved Studies',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createExpiringStudiesCard: function createExpiringStudiesCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var studyHelper = new SPFHelper(Study.all(), {
          autoFetch: true,
          filter: {
            format: dh.filterFormatters
          }
        }),
        dropdown = new Dropdown({
          inline: true,
          pointing: 'down'
        }),
        header = null;
      if (options.authority !== User.IRB_ADMIN) {
        studyHelper.filter.set({
          role: options.authority
        });
      }
      studyHelper.sort.set(Sort.SORT_FIELD, 'expirationDate').set(Sort.SORT_DIRECTION, Sort.ASCENDING);
      function applyFilter() {
        studyHelper.filter.set({
          expirationDate: dropdown.value.get('text')
        });
      }
      studyHelper.paginate.set(Paginate.SIZE, options.pageSize);
      dropdown.collection = new Backbone.Collection([{
        text: '30 days'
      }, {
        text: '60 days'
      }, {
        text: '90 days'
      }]);
      dropdown.childBindings.text = 'text';
      dropdown.on('change:value', applyFilter);
      dropdown.value = dropdown.collection.at(0);
      applyFilter();
      var ExpiringStudiesCardContainerView = CardContainerWithDropdownView.extend({
        dropdown: dropdown,
        labelSlug: p('Dashboard.Cards.StudiesExpiringIn.Clean')
      });
      header = new ExpiringStudiesCardContainerView().add(new TextView({
        tagName: 'h3',
        text: new Handlebars.SafeString(p('Dashboard.Cards.StudiesExpiringIn')),
        color: 'blue'
      })).add(dropdown);
      return dh.createCard({
        collection: studyHelper.collection,
        filter: studyHelper.filter,
        linkName: 'study:list',
        rowLinkName: 'study:detail',
        emptyViewOptions: {
          text: 'No Expiring Studies',
          icon: 'smile'
        },
        header: header,
        color: 'primary',
        columns: dh.studyColumns,
        viewAllHelpText: 'Studies Expiring In ',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createExpiredStudiesCard: function createExpiredStudiesCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var studyHelper = new SPFHelper(Study.all(), {
        autoFetch: true,
        filter: {
          format: dh.filterFormatters
        }
      });
      studyHelper.paginate.set(Paginate.SIZE, options.pageSize);
      studyHelper.filter.set({
        expirationDate: 'Expired'
      });
      if (options.authority !== User.IRB_ADMIN) {
        studyHelper.filter.set(FILTER_KEY__ROLE, options.authority);
      }
      studyHelper.sort.set(Sort.SORT_FIELD, 'expirationDate').set(Sort.SORT_DIRECTION, Sort.DESCENDING);
      return dh.createCard({
        collection: studyHelper.collection,
        filter: studyHelper.filter,
        linkName: 'study:list',
        rowLinkName: 'study:detail',
        emptyViewOptions: {
          text: 'No Expired Studies',
          icon: 'smile'
        },
        color: 'primary',
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.ExpiredStudies')),
          color: 'blue'
        }),
        columns: dh.studyColumns,
        viewAllHelpText: 'Expired Studies',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createReviewerSubmissionsCard: function createReviewerSubmissionsCard(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var submissionHelper = new SPFHelper(Document.submissions(), {
          autoFetch: true
        }),
        dropdown = null,
        header = null,
        primaryReviewerAssignment = 'primaryReviewerAssignment',
        secondaryReviewerAssignment = 'secondaryReviewerAssignment',
        reviewerAssignment = 'reviewerAssignment';
      function applyFilter() {
        var assignment = dropdown.value.get('value');
        if (primaryReviewerAssignment === assignment) {
          submissionHelper.filter.set(FILTER_KEY__CASE, 'reviewerInPrimaryReview');
        } else if (secondaryReviewerAssignment === assignment) {
          submissionHelper.filter.set(FILTER_KEY__CASE, 'reviewerInSecondaryReview');
        } else if (reviewerAssignment === assignment) {
          submissionHelper.filter.set(FILTER_KEY__CASE, 'reviewerInReview');
        }
        submissionHelper.filter.set(FILTER_KEY__ASSIGNMENT, dropdown.value.get('text'));
      }
      if (options.authority !== User.IRB_ADMIN) {
        submissionHelper.filter.set(FILTER_KEY__ROLE, options.authority);
      }
      submissionHelper.filter.set('status', Document.UNDER_REVIEW.join('|'));
      submissionHelper.paginate.set(Paginate.SIZE, options.pageSize);
      submissionHelper.sort.set(dh.submissionSort);
      dropdown = new Dropdown({
        inline: true,
        pointing: 'down'
      });
      dropdown.collection = new Backbone.Collection([{
        text: p('Assignments.PI'),
        value: primaryReviewerAssignment
      }, {
        text: p('Assignments.SecondaryReviewer'),
        value: secondaryReviewerAssignment
      }, {
        text: p('Assignments.Reviewer'),
        value: reviewerAssignment
      }]);
      dropdown.childBindings.text = 'text';
      dropdown.on('change:value', applyFilter);
      dropdown.value = dropdown.collection.at(0);
      var ReviewerSubmissionsCardContainerView = CardContainerWithDropdownView.extend({
        dropdown: dropdown,
        labelSlug: p('Dashboard.Cards.SubmissionsWhereIAm.Clean')
      });
      header = new ContainerView().add(new TextView({
        tagName: 'h3',
        text: new Handlebars.SafeString(p('Dashboard.Cards.SubmissionsWhereIAm')),
        color: 'blue'
      })).add(dropdown);
      return dh.createCard({
        collection: submissionHelper.collection,
        filter: submissionHelper.filter,
        linkName: 'submission:list',
        rowLinkName: 'submission:detail',
        emptyViewOptions: {
          text: 'You Have No Submissions'
        },
        header: header,
        color: 'primary',
        columns: dh.submissionColumns,
        viewAllHelpText: 'Submissions Where I am ',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createRecentOrgSubmissions: function createRecentOrgSubmissions(options) {
      options = _.extend({}, dashboardHelper.cardDefaults, options);
      var submissionHelper = new SPFHelper(Document.submissions(), {
        autoFetch: true
      });
      if (options.authority !== User.IRB_ADMIN) {
        submissionHelper.filter.set(FILTER_KEY__ROLE, options.authority);
      }
      submissionHelper.filter.set(FILTER_KEY__CASE, options["case"]);
      submissionHelper.paginate.set(Paginate.SIZE, options.pageSize);
      submissionHelper.sort.set(dh.submissionSort);
      return dh.createCard({
        collection: submissionHelper.collection,
        filter: submissionHelper.filter,
        sort: submissionHelper.sort,
        emptyViewOptions: {
          text: 'No Recent Submissions'
        },
        linkName: 'submission:list',
        rowLinkName: 'submission:detail',
        color: 'primary',
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.RecentOrgSubmissions')),
          color: 'blue'
        }),
        columns: dh.submissionColumns,
        viewAllHelpText: 'Recent Org Submissions',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createAnalystSubmissionsCard: function createAnalystSubmissionsCard(options) {
      options = _.extend({}, dh.cardDefaults, options);
      var submissionsHelper = new SPFHelper(Document.submissions(), {
          autoFetch: true,
          filter: {
            format: dh.filterFormatters
          }
        }),
        dropdown = null,
        header = null,
        isAdmin = User.IRB_ADMIN === options.authority,
        empty = 'empty',
        me = 'me';
      var applyFilter = function applyFilter() {
        var assignment = dropdown.value.get('value');
        if (empty === assignment) {
          submissionsHelper.filter.set(FILTER_KEY__CASE, isAdmin ? CASE__ADMIN_UNASSIGNED : CASE__ANALYST_UNASSIGNED);
          submissionsHelper.filter.unset(FILTER_KEY__ASSIGNMENT);
          submissionsHelper.filter.set(analystFormatter.ANALYST_FIELD, analystFormatter.UNASSIGNED);
        } else if (me === assignment) {
          submissionsHelper.filter.set(FILTER_KEY__CASE, isAdmin ? CASE__ADMIN_ME : CASE__ANALYST_ME);
          submissionsHelper.filter.unset(analystFormatter.ANALYST_FIELD);
          submissionsHelper.filter.set(FILTER_KEY__ASSIGNMENT, 'Analyst');
        }
      };
      submissionsHelper.paginate.set(Paginate.SIZE, options.pageSize);
      submissionsHelper.sort.set(dh.submissionSort);
      dropdown = new Dropdown({
        inline: true,
        pointing: 'down'
      });
      dropdown.collection = new Backbone.Collection([{
        text: p('Dashboard.Cards.Unassigned'),
        value: empty
      }, {
        text: p('Dashboard.Cards.AssignedToMe'),
        value: me
      }]);
      dropdown.childBindings.text = 'text';
      dropdown.on('change:value', applyFilter);
      dropdown.value = dropdown.collection.at(0);
      var AnalystSubmissionsCardContainerView = CardContainerWithDropdownView.extend({
        dropdown: dropdown,
        labelSlug: p('Dashboard.Cards.SubmissionsThatAre.Clean')
      });
      header = new AnalystSubmissionsCardContainerView().add(new TextView({
        tagName: 'h3',
        text: new Handlebars.SafeString(p('Dashboard.Cards.SubmissionsThatAre')),
        color: 'blue'
      })).add(dropdown);
      return dh.createCard({
        collection: submissionsHelper.collection,
        filter: submissionsHelper.filter,
        linkName: 'submission:list',
        rowLinkName: 'submission:detail',
        emptyViewOptions: {
          text: 'No Submissions'
        },
        color: 'primary',
        header: header,
        columns: dh.submissionColumns,
        viewAllHelpText: 'Submissions That Are ',
        columnNames: ['IRB Number', 'Study Title']
      });
    },
    createUnderReviewSubmissionCard: function createUnderReviewSubmissionCard(options) {
      var theButtons = dh.createReviewTypeButtons(false, options.authority, options);
      var content = new ContainerView().add(theButtons[config.FULL_REVIEW_TYPE]).add(theButtons[config.EXPEDITED_REVIEW_TYPE]).add(theButtons[config.LIMITED_REVIEW_TYPE]).add(theButtons[config.EXEMPT_REVIEW_TYPE]).add(theButtons[config.ADMIN_REVIEW_TYPE]);
      var card = dh.createCard({
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.SubmissionsUnderReview')),
          color: 'blue'
        }),
        color: 'primary',
        content: content,
        viewAllHelpText: 'Submissions Under Review'
      });
      return card;
    },
    createMeetingsCard: function createMeetingsCard(options) {
      options = _.extend({}, dh.cardDefaults, options);
      var calendar = new Calendar({
        fluid: true,
        verticalFluid: true,
        selectable: true,
        aligned: 'center',
        appointmentDot: true
      });
      calendar.controls.fluid = true;
      calendar.collection = Meeting.collection();
      calendar.childBindings.eventDate = 'startDate';
      var loaderHelper = new LoaderHelper([calendar.collection]),
        meetingPopup = new PopupView({
          showOn: 'click',
          size: PopupView.LARGE
        }),
        popupTimeout = null,
        meetingSummary = new MeetingSummary(),
        dayModel = new Backbone.Model(),
        meetingCount = new ContainerView().add(new ButtonView({
          text: 'View Week',
          color: 'primary',
          model: new RouteHelper('meeting:list').add(dayModel),
          bindings: {
            link: 'link'
          }
        }));
      meetingSummary.more.bindings.link = 'link';
      var currentDayView = null;
      var popupHideDelay = function popupHideDelay(cb) {
        clearTimeout(popupTimeout);
        popupTimeout = setTimeout(cb, 10);
      };
      calendar.listenTo(meetingPopup, 'hidden', function () {
        meetingSummary.model = null;
        currentDayView = null;
      }).on('change:start change:end', _.debounce(function () {
        var start = +calendar.start,
          end = +calendar.end;
        calendar.collection.params({
          start: start,
          end: end
        }).fetch();
      })).on('destroy', function () {
        meetingPopup.destroy();
        meetingSummary.destroy();
        meetingCount.destroy();
      }).on('day:press', function (dayView) {
        if (currentDayView == dayView) {
          return;
        }
        if (dayView.appointments.length === 1) {
          popupHideDelay(function () {
            currentDayView = dayView;
            meetingSummary.model = dayView.appointments.at(0);
            meetingSummary.more.model = new RouteHelper('meeting:detail').add(meetingSummary.model, {
              meetingId: 'id'
            });
            meetingSummary.agenda.model = meetingSummary.model;
            meetingSummary.render();
            meetingPopup.content = meetingSummary;
            meetingPopup.showNow(currentDayView);
          });
        } else if (dayView.appointments.length != 1) {
          popupHideDelay(function () {
            currentDayView = dayView;
            dayModel.set({
              tab: 'week',
              month: dayView.moment.month(),
              year: dayView.moment.year(),
              date: +dayView.moment
            });
            if (meetingCount.at(0) instanceof TextView) {
              meetingCount.removeView(meetingCount.at(0));
            }
            meetingCount.add(new TextView({
              tagName: 'h4',
              className: 'ui header',
              text: (dayView.appointments.length || 'No') + ' Meetings'
            }), {
              at: 0
            });
            meetingPopup.content = meetingCount;
            meetingPopup.showNow(currentDayView);
          });
        }
      });
      loaderHelper.set('loading', true);
      var card = dh.createCard({
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.MyMeetings')),
          color: 'blue'
        }),
        color: 'primary',
        content: calendar,
        viewAllHelpText: 'My Meetings calendar'
      });
      card.loader.model = loaderHelper;
      card.loader.bindings.active = 'loading';
      return card;
    },
    createUpcomingReviewsCard: function createUpcomingReviewsCard(options) {
      options = _.extend({}, dh.cardDefaults, options);
      var today = new Date();
      var collection = Meeting.collection().params({
        start: today.getTime(),
        end: moment(today).add(30, 'days').toDate().getTime()
      });
      return dh.createCard({
        header: new TextView({
          tagName: 'h3',
          text: new Handlebars.SafeString(p('Dashboard.Cards.UpcomingReviews')),
          color: 'blue'
        }),
        collection: collection,
        color: 'primary',
        rowLinkName: 'meeting:detail',
        emptyViewOptions: {
          text: 'No Upcoming Meetings'
        },
        columns: [{
          data: 'startDate',
          formatter: dateFormatter(config.dateFormat, 'N/A'),
          collapsing: true,
          dataType: 'date'
        }, {
          data: 'title',
          formatter: boldFormatter
        }, {
          data: 'startDate',
          formatter: dateFormatter('LT'),
          dataType: 'time'
        }, {
          data: 'location'
        }],
        viewAllHelpText: 'Upcoming Meetings',
        columnNames: ['Date', 'Board name', 'Time', 'Location']
      });
    },
    createButtonWithSharedCollection: function createButtonWithSharedCollection(options) {
      options = options || {};
      var dashboardButton = new DashboardButton(_.extend({
        fluid: true
      }, options));
      if (options.linkName) {
        dashboardButton.link = new RouteHelper(options.linkName, options.linkFilter).ignore('role').get('link');
      }
      if (options.bindings) {
        _.extend(dashboardButton.bindings, options.bindings);
      }
      dashboardButton.loader.model = options.loaderHelper;
      dashboardButton.loader.bindings.active = 'loading';
      return dashboardButton;
    },
    createButton: function createButton(options) {
      options = options || {};
      var collection = options.collection,
        spfHelper = null,
        loaderHelper = null,
        dashboardButton = new DashboardButton(_.extend({
          fluid: true
        }, options));
      if (collection) {
        spfHelper = new SPFHelper(collection);
        if (options.filter) {
          spfHelper.filter.set(options.filter);
        }
        spfHelper.paginate.set(Paginate.SIZE, 1).on('change', function (paginate) {
          dashboardButton.text = paginate.get(Paginate.TOTAL_ITEMS) || '0';
        });
        loaderHelper = new LoaderHelper([collection]);
        dashboardButton.loader.model = loaderHelper;
        dashboardButton.loader.bindings.active = 'loading';
        if (options.linkName) {
          dashboardButton.link = new RouteHelper(options.linkName, spfHelper.filter).ignore(FILTER_KEY__ROLE).ignore(FILTER_KEY__CASE).get('link');
        }
        if (options.model) {
          dashboardButton.model = options.model;
        }
        if (options.bindings) {
          _.extend(dashboardButton.bindings, options.bindings);
        }
      }
      return dashboardButton;
    },
    createCard: function createCard(options) {
      var content = options.content,
        buttonResetVisible = false,
        dashboardCard = null;
      if (!content) {
        content = new TableView({
          collection: options.collection,
          borderless: true,
          basic: true,
          headless: true,
          compact: true,
          unstackable: true,
          sortable: false,
          selectable: true
        });
        content.emptyView = options.emptyView || EmptyTableView.Row;
        content.emptyViewOptions = _.extend({
          opacity: null
        }, options.emptyViewOptions);
        content.columns.add(options.columns || []);
        content.on('before:render:empty', function () {
          if (dashboardCard.button) {
            buttonResetVisible = dashboardCard.button.visible;
            dashboardCard.button.visible = false;
          }
          content.$el.css('height', '100%');
        });
        content.on('before:remove:empty', function () {
          if (dashboardCard.button) {
            dashboardCard.button.visible = buttonResetVisible;
          }
          content.$el.css('height', '');
        });
        if (options.rowLinkName) {
          var getMapping = function getMapping(model) {
            var mapping = null;
            if (model instanceof Document) {
              mapping = {
                studyId: 'studyId',
                documentId: 'id'
              };
            } else if (model instanceof Task) {
              mapping = {
                studyId: 'studyId',
                documentId: 'documentId'
              };
            } else if (model instanceof Study) {
              mapping = {
                studyId: 'id'
              };
            } else if (model instanceof Meeting) {
              mapping = {
                meetingId: 'id'
              };
            }
            return mapping;
          };
          var getRowLink = function getRowLink(model) {
            return new RouteHelper(options.rowLinkName).ignore(FILTER_KEY__ROLE).ignore(FILTER_KEY__CASE).add(model, getMapping(model)).get('link');
          };
          content.on('row:press', function (row) {
            app.navigate(getRowLink(row.model), {
              trigger: true
            });
          });
          content.rowLinkFormatter = function (model) {
            return getRowLink(model);
          };
        }
      }
      dashboardCard = new DashboardCard({
        header: options.header instanceof Backbone.View ? options.header : new TextView({
          tagName: 'h3',
          text: options.header
        }),
        collection: options.collection,
        color: options.color,
        content: content
      });
      if (content instanceof TableView || content instanceof Calendar) {
        dashboardCard.once('render', function () {
          if (content instanceof Calendar) {
            dashboardCard.ui.body.css('padding-left', '0').css('padding-right', '0').css('padding-bottom', '0').css('overflow-x', '').css('overflow-y', '');
          } else {
            dashboardCard.ui.body.css('padding', '0');
          }
        });
      }
      if (options.linkName) {
        dashboardCard.button.model = new RouteHelper(options.linkName).ignore(FILTER_KEY__ROLE).ignore(FILTER_KEY__CASE);
        if (options.filter) {
          dashboardCard.button.model.add(options.filter);
        }
        if (options.sort) {
          dashboardCard.button.model.add(options.sort);
        }
        dashboardCard.button.bindings.link = 'link';
        dashboardCard.button.visible = true;
        dashboardCard.button.text = options.linkText || p('Dashboard.Cards.ViewMore');
      }
      if (options.link) {
        dashboardCard.button.visible = true;
        dashboardCard.button.link = options.link;
        dashboardCard.button.text = options.linkText || p('Dashboard.Cards.ViewMore');
      }
      if (options.collection) {
        dashboardCard.loader.model = new LoaderHelper([options.collection]);
        dashboardCard.loader.model.set('loading', true);
        dashboardCard.loader.bindings.active = 'loading';
      }
      dashboardCard.on('content:dropdown:render', function () {
        $(dashboardCard.button.el).attr("aria-label", p('Dashboard.Cards.ViewMore') + ' ' + options.viewAllHelpText + $(dashboardCard.header.el).find('.dropdown .text').text());
      });
      content.on('row:focus', function (row) {
        if (options.columnNames) {
          var ariaLabel = options.columns.map(function (column, index) {
            var rowValue = row.model.attributes[column.data || column.childViewOptions.bindings.text];
            return options.columnNames[index] + ": " + (column.dataType === 'date' ? new Date(rowValue).toDateString() : column.dataType === 'time' ? $($($(row.el).find('td')[index]).find('span')).text() : rowValue) + "; ";
          });
          $(row.el).attr('aria-label', ariaLabel);
        }
      });
      dashboardCard.on('render', function () {
        if (!$(this.el).find('.ui.table').length) {
          $(this.el).find('.ui.segment.content.body').attr({
            'aria-label': options.viewAllHelpText,
            'tabindex': '0'
          });
        }
        if ($(content.el).find('tr.empty').length) {
          $(content.el).removeAttr("aria-labelledby");
          $(content.el).attr("aria-label", options.viewAllHelpText + $(dashboardCard.header.el).find('.dropdown .text').text());
        }
      });
      dashboardCard.on('header:childview:item:select', function () {
        $(this.button.el).attr("aria-label", p('Dashboard.Cards.ViewMore') + ' ' + options.viewAllHelpText + $(dashboardCard.header.el).find('.dropdown .text').text());
        $(this.content.el).attr("aria-label", options.viewAllHelpText + $(dashboardCard.header.el).find('.dropdown .text').text());
      });
      return dashboardCard;
    }
  };
  module.exports = dashboardHelper;
});

